import type { DocumentItem } from 'src/components/pages/info/document/index/types'

type Translate = (_text: string) => string

export default function getByDocuments(staticPath: string, translate: Translate): DocumentItem[] {
  const base = `${staticPath}_v1/ydoc/documents/info/by`

  return [
    {
      id: 'by-branch',
      title: translate('Филиал в Беларуси'),
      alt: translate('Филиал в Беларуси'),
      previewSrc: `${base}/Филиал_в_Беларуси.png`,
      src: `${base}/Филиал_в_Беларуси.png`,
    },
  ]
}
